import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  button,
  input,
  select,
  textarea {
    cursor: pointer;
  }

  button,
  input,
  select,
  table,
  textarea {
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.4px;
    border: 0;
    margin: 0;
    padding: 0;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    line-height: 1.2;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.4px;
  }

  body {
    background-color: rgba(210, 216, 228, 0.4);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ol,
  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: black;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  span {
    display: inline-block;
  }

  img {
    vertical-align: middle;
  }

  textarea {
    outline: none;
  }

  /* 아이폰 input 둥근테두리 그림자 제거 */
  input {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    outline: none;
  }

  input[type="checkbox"] {
    -webkit-appearance: checkbox;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #f2f4f5 inset !important;
  }

  /* select 화살표 없애기 */

  select {
    outline: none;
    background: white;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0;
  }

  select::-ms-expand {
    display: none;
  }

  fieldset {
    border: 0;
  }

  legend {
    display: none;
  }

  html,
  body {
    height: 100%;
    font-family: Pretendard, NotoSansJK, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans,
    Helvetica Neue, sans-serif;
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }

  .App {
    position: relative;
  }

`;

export default GlobalStyles;
